import { useState, useEffect } from 'react'
import axios from 'axios'
import '../css/miniprint.css'

import info from '../img/icons8-información-50.png'
import close from "../img/close.svg"
const initialDb = []

const Peces = () => {
  
  const [db, setDb] = useState(initialDb)

  const [isModalOpen, setIsModalOpen] = useState(false)

  const [currentIndex, setCurrentIndex] = useState(0)

    const [infor, setInfor ] = useState(false)


    useEffect(() => {
  if (isModalOpen) {
    document.body.style.overflow = 'hidden';
  }else{
    document.body.style.overflow = 'auto';
  }

  return()=>{
    document.body.style.overflow= 'auto'
  }
}, [isModalOpen])


  const getData = async () => {
    const ENDPOINT = "https://elsaback-q7jq.onrender.com/peces"
    const res = await axios.get(ENDPOINT),
      json =await res.data;

    setDb(json)
  }

  useEffect(() => {
    getData()
  }, [])
  
  const openModal = (index) => {
    setCurrentIndex(index)
    setIsModalOpen(true)
  }
  
  const closeModal = () => setIsModalOpen(false)

     const openInfo = () => {

        setInfor(true)
    }
    const closeInfo = () => setInfor(false) 

  const goNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % db.length)
  }

  const goPrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + db.length) % db.length)
  }

   const capitalizar = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  return (
    <>
    <div className='sectionGaleria'>
    <div className='intro'>
          <h2>Peces: Nadar entre mundos</h2>
          <p>
          Esta serie nos sumerge en un universo acuático donde las formas se deslizan con suavidad y los paisajes se diluyen entre corrientes.
            Los peces no son solo criaturas del agua: son símbolos de movimiento, introspección y conexión con lo profundo.

            Cada obra es una travesía visual que invita a perderse en los detalles, a seguir la línea de una aleta o un remolino, y a descubrir un ecosistema imaginario, íntimo y poético.
                En Peces, el agua no solo contiene: transforma, guía y revela.
          </p>
    </div>
      {
        db.map((item, index) => <div key={item._id} className='divDb' onClick={() => openModal(index)} >
          <div className='h3box'><h3 className='h3'>{item.name}</h3></div> 
          <img className='imgMiniprint' src={item.image} alt={item.name} />
          
        </div>)
      }
    </div>
    {isModalOpen && (
      <div className='modal'>
         {db[currentIndex].description  &&
                        <img src={info} className='informacion' alt='caracteristicas' onClick={openInfo}/>
                    }
        <img src={close}  alt="cerrar" className='close' onClick={closeModal}/>
        <span className='arrow left' onClick={goPrev}>‹</span>
        <img className='modal-img' src={db[currentIndex].image} alt={db[currentIndex].name} />
        <span className='arrow right' onClick={goNext}>›</span>
                   <h4 className='h4Name'>{capitalizar(db[currentIndex].name)}</h4>
        <h4 className='h4Size'>{db[currentIndex].size}</h4>
      </div>
    )}
     {infor  && (
                <div className='informacionContainer'>

                <div className='inf'>
                        <div style={{display:'flex', width:'100%', justifyContent:'end'}}>
                            <span className='closeInformacion' onClick={closeInfo}>×</span>
                        </div>
                        
                        <h4 className='h4InfName'>{db[currentIndex].name.toUpperCase()}</h4>
                        <h4 className='description' style={{
                            fontWeight:'400'
                        }}>{db[currentIndex].description}</h4>
                        <h4 className='description' style={{
                            fontWeight:'400'
                        }}>Medidas: {db[currentIndex].size}</h4>
                        
                </div>
                    
                </div>
            )

            }
    </>
  )
}

export default Peces